export class Alert {
  #reset = null;
  #dialog = null;
  #title = null;
  #msg = null;
  #body = null;
  #icon = null;
  #close = null
  #delay = null;
  #fa_icon = '';
  #icon_color = '';


  constructor() {
    this.#dialog = document.getElementById('alert-dialog');
    this.#title = this.#dialog.querySelector('.card-header-title');
    this.#icon = this.#dialog.querySelector('.alert-icon');
    this.#msg = this.#dialog.querySelector('.alert-msg');;
    this.#body = this.#dialog.querySelector('.alert-body');;

    this.#close = this.#dialog.querySelector('.card-header-icon');
    this.#close.addEventListener('click', () => this.close() );

    this.#dialog.querySelector('.buttons-container').addEventListener('click', (ev) => this.clicked(ev) );
    this.callback = null;


  }

  message(title, text, callback, icon) {

    this.#dialog.querySelector('.message-set').classList.remove('is-hidden');
    this.#dialog.querySelector('.confirm-set').classList.add('is-hidden');

    this.configureDialog(title, text, callback, icon)

    this.#dialog.showModal();
  }

  confirm(title, text, callback, icon, onShow, position) {

    this.#dialog.querySelector('.message-set').classList.add('is-hidden');
    this.#dialog.querySelector('.confirm-set').classList.remove('is-hidden');

    this.configureDialog(title, text, callback, icon)

    this.#dialog.showModal();
  }

  configureDialog(title, text, callback, icon) {

    this.#title.innerHTML = title;
    const lines = text.split('<br>');
    this.callback = callback;
    this.setIcon(icon);

    const header_icon = this.#dialog.querySelector('.card-header-icon').classList;
    icon == 'notify' ? header_icon.add('is-hidden') : header_icon.remove('is-hidden');

    const header = this.#title.parentElement.classList;
    header.remove(header[header.length - 1])
    header.add(`${this.#icon_color.replace('text', 'background')}-dark`)

    this.#icon.innerHTML = `<i class="fad fa-swap-opacity ${this.#fa_icon} ${this.#icon_color}"></i>`;
    this.#msg.innerHTML = lines.shift();
    this.#body.innerHTML = lines.join('<br>');
  }

  preventCancel(ev) {
    event.preventDefault();
  }

  notify(text, delay) {
    this.#dialog.querySelector('.message-set').classList.add('is-hidden');
    this.#dialog.querySelector('.confirm-set').classList.add('is-hidden');

    this.configureDialog('Please Wait', text, null, 'notify')
    this.#dialog.addEventListener('cancel', this.preventCancel);

    if (delay) {
      this.#delay = setTimeout(() => this.#dialog.showModal(), delay)
    }
    else {
      this.#dialog.showModal();
    }
  }

  clicked(ev) {
    const btn = ev.target.closest('button');

    if (btn) {
      switch (btn.innerText) {
        case 'Yes':
        case 'Ok':
          if (this.callback) {
            if (this.callback() !== false) {
              this.#close.click();
            }
          }
          else {
            this.#close.click();
          }
          break;

        case 'No':
          if (this.#reset) {
            setTimeout(function() {this.#reset(); this.#reset = null},100);
          }
          this.#close.click();
          break;

        default:
          this.#close.click();
          break;
      }
    }
  }

  close() {
    try {
      clearTimeout(this.#delay);
      this.#delay = null;
      this.#dialog.close();
    }
    catch (e) {
      // Do nothing
    }
    window.removeEventListener('cancel', this.preventCancel);
  }

  addUrlTooltip(el, title) {
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    // This function adds a dynamic Tooltip. It gets it's lookup from the data-url property of the supplied element
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    $(el).qtip({
      position: {
        my: 'top right',  // Position my top left...
        at: 'bottom right', // at the bottom right of...
        target: 'event' // my target
      },
      content: {
        title: title,
        text(event, api) {
          // Return the deferred object
          return $.ajax({
            url: this.data('url') // Use data-url attribute for the URL
          })
          .then(function(content) {
            // Return the content instead of using .set(). If you're wanting to select
            // specific elements, see ther above section and adapt the `api.set` call
            // into a `return elements` statement!
            return content
          }, function(xhr, status, error) {
            // Errors aren't handled by the library automatically, so
            // you'll need to call .set() upon failure, just as before.
            api.set('content.text', status + ': ' + error);
          });
        }
      }
    });
  }

  rmUrlTooltip(el) {
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    // This function removes the dynamic Tooltip of the supplied el
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    $(el).qtip('destroy', true);
  }

  setFailMsg(jqXHR, id) {
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    // This function sets the inline messages using in bulma dialogs
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    if (jqXHR.status == 403) {
      window.location.reload(true);
    }
    else {
      const msg = JSON.parse(jqXHR.responseText);
      const el = document.getElementById(id);

      if (el) {
        el.classList.value = '';
        el.classList.add('notification', 'is-radiusless', msg.background || 'has-background-warning', msg.color || 'has-text-warning-dark');
        el.innerHTML = msg.message;
      }

      if (msg.focus && document.querySelector(msg.focus)) {
        document.querySelector(msg.focus).focus();
      }

      if (msg.clear && document.querySelector(msg.clear)) {
        document.querySelector(msg.clear).value = '';
      }
    }
  }

  reset(msg) {
    if (msg.focus && document.querySelector(msg.focus)) {
      document.querySelector(msg.focus).focus();
      document.querySelector(msg.focus).value = '';
    }
    if (msg.clear && document.querySelector(msg.clear)) {
      document.querySelector(msg.clear).value = '';
    }
  }

  showFailMsg(jqXHR, callback) {
    const msg = JSON.parse(jqXHR.responseText || jqXHR);
    this.callback = callback;

    this.close();

    if (msg.confirm) {
      this.#reset = this.reset(msg);

      this.confirm(
        msg.title,
        msg.message,
        () => {
          if (msg.focus && document.querySelector(msg.focus)) {
            setTimeout(() => {document.querySelector(msg.focus).focus()}, 100);
          }
          if (msg.clear && document.querySelector(msg.clear)) {
            document.querySelector(msg.clear).value = '';
          }
          if (callback && (callback instanceof Function)) {
            callback(msg);
          }
        },
        msg.icon
      )
    }
    else {
      this.message(
        msg.title,
        msg.message,
        () => {
          if (msg.focus && document.querySelector(msg.focus)) {
            setTimeout(() => {document.querySelector(msg.focus).focus()}, 100);
          }
          if (msg.clear && document.querySelector(msg.clear)) {
            document.querySelector(msg.clear).value = '';
          }
          if (callback && (callback instanceof Function)) {
            callback(msg);
          }
        },
        msg.icon
      );
    }
  }

  showJsonMsg(msg, callback) {
    setTimeout(_ => {document.querySelector('#busy-indicator').style.display = 'none'}, 500);

    if (msg.confirm) {
      this.#reset = this.reset(msg);

      this.confirm(
        msg.title,
        msg.message,
        () => {
          if (msg.focus) {
            setTimeout(() => {document.querySelector(msg.focus).focus()}, 100);
          }
          if (msg.clear) {
            document.querySelector(msg.clear).value = '';
          }
          if (callback && (callback instanceof Function)) {
            return callback(msg);
          }
        },
        msg.icon
      )
    }
    else {
      this.message(
        msg.title,
        msg.message,
        () => {
          if (msg.focus && document.querySelector(msg.focus)) {
            setTimeout(() => {document.querySelector(msg.focus).focus()}, 100);
          }
          if (msg.clear && document.querySelector(msg.clear)) {
            document.querySelector(msg.clear).value = '';
          }
          if (callback && (callback instanceof Function)) {
            return callback(msg);
          }
        },
        msg.icon
      );
    }
  }

  setIcon(icon) {
    switch (icon) {
      case 'error':
        this.#fa_icon = 'fa-exclamation-circle';
        this.#icon_color = 'has-text-danger';
        break;
      case 'question':
        this.#fa_icon = 'fa-question-circle';
        this.#icon_color = 'has-text-primary';
        break;
      case 'save':
        this.#fa_icon = 'fa-save';
        this.#icon_color = 'has-text-link';
        break;
      case 'success':
        this.#fa_icon = 'info-circle';
        this.#icon_color = 'has-text-success';
        break;
      case 'warning':
        this.#fa_icon = 'fa-exclamation-triangle';
        this.#icon_color = 'has-text-warning';
        break;
      case 'notify':
        this.#fa_icon = 'fa-spinner-third fa-spin';
        this.#icon_color = 'has-text-info';
        break;
      default:
        this.#fa_icon = 'fa-info-circle';
        this.#icon_color = 'has-text-info';
        break;
    }
  }
}

